import type { IContact } from 'src/services/api/contacts/types';

export const contactDisplayName = (contact: Pick<IContact, 'name' | 'email'>): string => {
    return contact.name || contact.email;
};
